import { zExt } from "@redotech/redo-model/common/zod-util";
import { z } from "zod";

export const addMerchantOverrides = {
  input: z.object({
    draftReturnId: zExt.objectId(),
    adjustmentOverrides: z.array(
      z.object({ pendingReturnItemId: z.string(), adjustment: z.number() }),
    ),
    greenReturnOverrides: z.array(
      z.object({ pendingReturnItemId: z.string(), greenReturn: z.boolean() }),
    ),
    customerPaysReturnShipping: z.boolean(),
    customerPaysNewOrderShipping: z.boolean(),
    flagReturn: z.boolean(),
    manualReview: z.boolean(),
    discountCodes: z.array(z.string()),
    applyAutomaticDiscounts: z.boolean(),
  }),
  output: z.object({ success: z.boolean() }),
};
